<!--
 * @Description: 
 * @Date: 2020-09-22 16:58:46
-->
<template>
  <!-- <ctList v-bind="$data" defaultText="没有找到相关内容，试试换一个搜索词" :defaultMid="true">
    <list :pType="type" :searchName="keyword" :defaultMid="false"></list>
  </ctList>-->
  <div style="background:#fff">
    <contentList :keyword="keyword"></contentList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { index } from '@/api/ajax';
import list from '@/views/list';
import ctList from '@/components/list/defaultList.vue';
import contentList from '@/components/list/contentList.vue';

import { contentSearch } from '@/api/ajax';

export default {
  data() {
    return {
      type: -1,
      listData: [],
      loading: true
    };
  },
  components: { list, ctList, contentList },
  watch: {},
  computed: {
    ...mapState({
      keyword: state => state.search.keyword
    })
  },
  methods: {
    onSubmit() {}
  },
  async created() {

  },
  beforeDestroy() {}
};
</script>

<style scoped lang='less'>
</style>
